module.exports = require('./_global');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/_path.js
 ** module id = 324
 ** module chunks = 0
 **/